import { useMemo, useContext } from 'react';
import { useRouter } from 'next/router';
import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { selectProductAndRegionIdsFromQuery } from '@/creditflowresearch/application/PageFilters/selectProductAndRegionIdsFromQuery';
import { ParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { getRegionAndProductFromDeal } from '@/creditflowresearch/application/helpers';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';

export interface IProductRegionIds {
  productIds: string[],
  regionIds: string[],
}

export const useProductRegionIds = (): IProductRegionIds => {
  const router = useRouter();
  const { products: productsList, regions: regionsList } = useHeaderMenuContext();
  const { products: accessibleProductsIds, regions: accessibleRegionsIds, plan } = useUserPlanContext();

  const parentContext = useContext(ParentPageContext);
  const deal: IDeal | ICorporateDeal | null = parentContext?.deal || null;
  const dealId = router.query.dealId as string | undefined;

  return useMemo(() => {
    const defaultProductsRegions = selectProductAndRegionIdsFromQuery({
      pathname: router.asPath,
      query: router.query,
      plan,
      productsList,
      regionsList,
      accessibleProductsIds,
      accessibleRegionsIds,
    });

    return getRegionAndProductFromDeal(
      dealId ? deal : null,
      defaultProductsRegions,
    );
  }, [
    productsList,
    regionsList,
    router.asPath,
    router.query,
    dealId,
    deal,
    plan,
    accessibleProductsIds,
    accessibleRegionsIds,
  ]);
};
